import {
  DatePickerField,
  SubmissionForm,
  TextInputField,
  TimePickerField,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { DateTime } from "@bps/date-time";

import { Validator } from "@bps/validator";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

export type BannerFormOnSubmit = (
  values: BannerFormSubmitValues
) => Promise<void>;

export interface BannerFormSubmitValues {
  text: string;
  startTime: DateTime;
  endTime: DateTime;
}

interface BannerFormValues {
  text: string;
  startDate: Date;
  startTime: string;
  endDate: Date;
  endTime: string;
}

interface BannerFormProps {
  onSubmit: BannerFormOnSubmit;
  isLoading?: boolean;
}

const bannerFormValidator = new Validator<BannerFormValues>(validator => ({
  text: validator.string().required(),
  startDate: validator.date().required(),
  startTime: validator.date().required(),
  endDate: validator.date().required(),
  endTime: validator.date().required()
}));

export const BannerForm: React.FC<BannerFormProps> = ({ onSubmit }) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    [Permissions.BhBannerWrite],
    "or"
  );

  const theme = useTheme();

  const _onSumbmit = async (values: BannerFormValues) => {
    const [startHour, startMinute] = values.startTime.split(":");
    const startTime = DateTime.fromJSDate(values.startDate).set({
      hour: Number(startHour),
      minute: Number(startMinute)
    });

    const [endHour, endMinute] = values.endTime.split(":");
    const endTime = DateTime.fromJSDate(values.endDate).set({
      hour: Number(endHour),
      minute: Number(endMinute)
    });
    await onSubmit({
      text: values.text,
      startTime,
      endTime
    });
  };

  return (
    <SubmissionForm<BannerFormValues>
      onSubmit={_onSumbmit}
      validate={bannerFormValidator.validate}
    >
      {() => (
        <Stack tokens={{ childrenGap: theme.spacing.s1 }}>
          <TextInputField
            name="text"
            multiline
            label="Add a text message to show as a banner message."
          />
          <Stack horizontal tokens={{ childrenGap: theme.spacing.s1 }}>
            <DatePickerField name="startDate" disabled={!hasWritePermission} />
            <TimePickerField name="startTime" disabled={!hasWritePermission} />
          </Stack>
          <Stack horizontal tokens={{ childrenGap: theme.spacing.s1 }}>
            <DatePickerField name="endDate" disabled={!hasWritePermission} />
            <TimePickerField name="endTime" disabled={!hasWritePermission} />
          </Stack>
        </Stack>
      )}
    </SubmissionForm>
  );
};
